import { CompanyTypeReq } from '~/types/CompanyType';
import { Application } from '~/types/Application';
import axios from './axios';

export type CompanyTypeParams = {
  isSynchronized: boolean | undefined;
};

export const companyType = (data: CompanyTypeReq, params?: CompanyTypeParams) => {
  return axios.post<Application>('/stages/companyType', data, { params }).then((res) => res.data);
};
